import React from 'react';

const Event = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.858 20.4174C19.731 20.4174 21.25 18.8994 21.251 17.0264V17.0244V14.3244C20.014 14.3244 19.012 13.3224 19.011 12.0854C19.011 10.8494 20.013 9.84637 21.25 9.84637H21.251V7.14637C21.253 5.27237 19.736 3.75237 17.863 3.75037H17.857H6.14498C4.27098 3.75037 2.75198 5.26837 2.75098 7.14237V7.14337V9.93337C3.94498 9.89137 4.94598 10.8254 4.98798 12.0194C4.98898 12.0414 4.98998 12.0634 4.98998 12.0854C4.99098 13.3204 3.99198 14.3224 2.75698 14.3244H2.75098V17.0244C2.74998 18.8974 4.26898 20.4174 6.14198 20.4174H6.14298H17.858Z"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3726 9.06364L12.9886 10.3106C13.0486 10.4326 13.1646 10.5176 13.2996 10.5376L14.6766 10.7386C15.0176 10.7886 15.1526 11.2066 14.9066 11.4456L13.9106 12.4156C13.8126 12.5106 13.7686 12.6476 13.7906 12.7826L14.0256 14.1526C14.0836 14.4916 13.7286 14.7496 13.4246 14.5896L12.1936 13.9426C12.0726 13.8786 11.9286 13.8786 11.8076 13.9426L10.5776 14.5896C10.2726 14.7496 9.91756 14.4916 9.97556 14.1526L10.2106 12.7826C10.2336 12.6476 10.1886 12.5106 10.0906 12.4156L9.09556 11.4456C8.84956 11.2066 8.98456 10.7886 9.32456 10.7386L10.7016 10.5376C10.8366 10.5176 10.9536 10.4326 11.0136 10.3106L11.6286 9.06364C11.7806 8.75564 12.2206 8.75564 12.3726 9.06364Z"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Event;